import QRCode from "react-qr-code"
import { useLocation, useParams } from "react-router-dom"
import { useNavigate } from "react-router-dom"

import LoadingSpinner from "@fuse/sharedComponents/loader/LoadingSpinner"
import FancyText from "@fuse/sharedComponents/typography/FancyText"
import { find, get } from "lodash-es"
import moment from "moment"
import { useRecoilState } from "recoil"
import { ROUTES } from "src/App"

import { userState } from "@fuse/recoil/signup"

import { useEventDetails } from "@api/services/events/useEventsApi"

const IndividualTicket = () => {
  const params = useParams()
  const eventId = get(params, "eventId", "")
  const attendeeId = get(params, "attendeeId", "")
  const { state } = useLocation()
  const { data: eventData, isLoading: eventLoading } = useEventDetails(eventId)
  const [user] = useRecoilState(userState)
  const navigate = useNavigate()

  const currentEventDetails = get(state || eventData, "data", {})

  const eventDetail = get(currentEventDetails, "eventDocData", {})
  const eventName = get(eventDetail, "eventName", "")
  const initiatorName = get(eventDetail, "initiatorName", "")
  const eventLocation = get(eventDetail, "location.eventLocation", "")
  const flyerImage = get(currentEventDetails, "eventDocData.flyerImage", "")

  const EventEventDate = get(eventDetail, "timing.eventDate", new Date())
  const EventStartTime = get(eventDetail, "timing.eventStartTime", new Date())
  const EventEndTime = get(eventDetail, "timing.eventEndTime", new Date())
  const displayTimezone = get(
    eventDetail,
    "timing.displayTimezone",
    "America/New_York",
  )

  const myBoughtTickets =
    get(currentEventDetails, "myTickets", []) ||
    get(eventData?.eventDocData, "myTickets", [])
  const myTicket = find(myBoughtTickets, function (ticket) {
    return get(ticket, "attendee", "") === attendeeId
  })
  const addOns = get(myTicket, "addOns", [])
  const ticketHolderName = get(myTicket, "name", user?.name)
  const ticketHolderTicketName = get(myTicket, "ticketName", "")

  const generateTicketQr = () => {
    const ticketInfo = {
      eventId: eventId,
      ticketId: get(myTicket, "ticketId", ""),
      attendee: get(myTicket, "attendee", ""),
    }
    return JSON.stringify(ticketInfo)
  }

  const formatDateWithMoment = (
    date: string | Date,
    format: string,
    displayTimezone: string,
  ) => {
    return moment(date).tz(displayTimezone).format(format)
  }

  const handleBackPress = () => {
    navigate(ROUTES.EVENTS.replace(":eventId", eventId))
  }

  return (
    <div className="w-full flex flex-col items-center mb-6 justify-start flex-grow mt-8 overflow-hidden">
      {eventLoading && !state?.data && <LoadingSpinner />}
      <div className="">
        <div className=" sm:w-[45vw]  max-w-md  min-w-max   relative  ">
          <div className="absolute  top-1/2 -translate-y-1/2 px-6 lg:px-8">
            <FancyText className="text-white font-semibold text-[1.125em] md:text-[1.5em] text-start">
              {eventName}
            </FancyText>
            <FancyText className="text-white font-normal text-sm md:text-lg text-start">
              by {initiatorName}
            </FancyText>
          </div>
          <div className="  ">
            <svg
              width={"100%"}
              className="aspect-[300/125]"
              viewBox="0 0 300 125"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              {/* Top Section */}

              <g className="layer" display="inline">
                <path
                  d="M0 21.8c0-11.44 8.88-20.8 19.74-20.8h260.53c10.86 0 19.74 9.36 19.74 20.8v88.22h0v3.99a11.84 12.48 0 0 0-12.96 11.99v0.01h-0.01H12.99l-0.01 0.02v-0.01a11.84 12.48 0 0 0-12.95-11.98v-3.41V21.8h0z"
                  fill="#7F7F7F"
                  fillOpacity={0.2}
                />
              </g>
            </svg>
          </div>
        </div>

        <div className=" sm:w-[45vw]  max-w-md  min-w-max relative">
          <div className="absolute top-1/2 -translate-y-1/2 px-6 lg:px-8 w-full">
            <FancyText className="text-white font-normal text-sm md:text-lg text-start">
              Location
            </FancyText>
            <FancyText className="text-white font-semibold text-sm md:text-lg text-start">
              {eventLocation}
            </FancyText>

            <div className="grid grid-cols-2 mt-1 md:mt-2">
              <div>
                <FancyText className="text-white font-normal text-sm md:text-lg text-start">
                  Name
                </FancyText>
                <FancyText className="text-white font-semibold text-sm md:text-lg text-start">
                  {ticketHolderName}
                </FancyText>
              </div>

              <div>
                <FancyText className="text-white font-normal text-sm md:text-lg text-start">
                  Date
                </FancyText>
                <FancyText className="text-white font-semibold text-sm md:text-lg text-start">
                  {moment(EventEventDate)
                    .tz(displayTimezone)
                    .format("DD MMM YYYY")}
                </FancyText>
              </div>
            </div>

            <div className="grid grid-cols-2 mt-1 md:mt-2">
              <div>
                <FancyText className="text-white font-normal text-sm md:text-lg text-start">
                  Time
                </FancyText>
                <FancyText className="text-white font-semibold text-sm md:text-lg text-start">
                  {`${formatDateWithMoment(EventStartTime, "h:mm A", displayTimezone)} ▸ ${formatDateWithMoment(
                    EventEndTime,
                    "h:mm A",
                    displayTimezone,
                  )}`}
                </FancyText>
              </div>

              <div>
                <FancyText className="text-white font-normal text-sm md:text-lg text-start">
                  Ticket type
                </FancyText>
                <FancyText className="text-white font-semibold text-sm md:text-lg text-start">
                  {ticketHolderTicketName}
                </FancyText>
              </div>
            </div>

            {addOns.length ? (
              <div className="mt-2 md:mt-2">
                <FancyText className="text-white font-normal text-sm md:text-lg text-start">
                  AddOns
                </FancyText>
                {addOns?.map((item) => (
                  <FancyText className="text-white font-semibold text-sm md:text-lg text-start">
                    {item?.ticketName}
                  </FancyText>
                ))}
              </div>
            ) : null}
          </div>
          <div>
            <svg
              width={"100%"}
              className="aspect-[300/247]"
              viewBox="0 0 300 247"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                {/* middle section */}
                <line
                  stroke="white"
                  strokeDasharray="3.47 3.47"
                  strokeOpacity="0.2"
                  strokeWidth="0.87"
                  x1="13.93"
                  x2="286.26"
                  y1="0.6"
                  y2="0.6"
                />

                {/* Main ticket shape */}
                <path
                  d="M13.12,0.02h0a11.84,11.54 0 0 1 -13,12.08h0l-0.02,219.76h0.01l0,2.99a11.84,11.54 0 0 1 12.88,12.08h0l-0.05,-0.01h272.12l0.03,0.04h-0.01a11.84,11.54 0 0 1 15.02,-11.98h-0.01l0,-3.28l0,-219.55h0a11.84,11.54 0 0 1 -12.98,-12.06h0l-274.09,-0.02h0z"
                  fill="#7F7F7F"
                  fillOpacity="0.2"
                />

                {/* Bottom dashed line */}
                <line
                  stroke="white"
                  strokeDasharray="3.47 3.47"
                  strokeOpacity="0.2"
                  strokeWidth="0.87"
                  x1="12.96"
                  x2="284.54"
                  y1="246.37"
                  y2="246.37"
                />
              </g>
            </svg>
          </div>
        </div>

        <div className=" sm:w-[45vw]  max-w-md  min-w-max relative ">
          <div className="absolute inset-0 flex items-center justify-center">
            <QRCode
              style={{ height: "auto" }}
              className="min-w-28 max-w-[14vw] aspect-square"
              value={generateTicketQr()}
              bgColor="transparent"
              fgColor="#FFFFFF"
              viewBox={`0 0 256 256`}
            />
          </div>
          <div className="w-full">
            {/* bottom section */}
            <svg
              width={"100%"}
              className="aspect-[300/220]"
              viewBox="0 0 300 220"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g className="layer">
                <path
                  d="M12.83,0.08l0.02,0.01a11.84,12 0 0 1 -12.81,11.97l-0.02,3.01l-0.03,184c0,11 8.88,21 19.74,21h260.53c10.86,0 19.74,-10 19.74,-21v-184l0.01,-2.95a11.84,12 0 0 1 -15.02,-12.02h-272.14l-0.02,0.01l-0.01,0.01z"
                  fill="#7F7F7F"
                  fillOpacity="0.2"
                />
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  )
}

export default IndividualTicket
